import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import lodash from 'lodash';

import LockSharpIcon from '@material-ui/icons/LockSharp';
import { Box, FormControl, Grid, MenuItem, Select, Typography } from '@mui/material';
import {
  DiscoveryCountryAvailableType,
  DiscoveryCountryCodeType,
  FilterVal,
  ListingsProp,
  MapPropTypes,
  OTAListingsProp,
  SearchProp,
  VisibleListingsProp,
  VisibleOTAListingsProp,
} from 'src/interfaces/iproptypes';
import GoogleMapReact from 'google-map-react';
import useSupercluster from 'use-supercluster';
import ClusterPointer from 'src/App/HOC/Pointer/ClusterPointer';
import { Pointer, SimplePointer } from 'src/App/HOC';
import {
  applySmartBounds,
  calculateBounds,
  convertBoundsObjToArray,
  convertListingsIntoGeoJSONArray,
  coordDistance,
  formatGoogleMapsBounds,
  getBoundedListings,
  getBoundedOTAListings,
  getDiscoveryMapViewParamsCountryWise,
  getVisibleListings,
  getVisibleOTAListings,
  isPointWithinBounds,
  mapOptions,
  safeMarkersLoad,
  safeOTAMarkersLoad,
  updateListings,
} from 'src/utils/functions';
import {
  Bounds,
  Coordinates,
  Listing,
  ListingVal,
  Listings,
  OTAListings,
  Submarket,
  Timer,
} from 'src/interfaces/idashboard';
import {
  CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD,
  COLOR_AIRBNB_MARKERS,
  COLOR_PRIMARY_DARK,
  COLOR_RANGE_AIRBNB_MARKERS,
  POINTER_GREEN,
  AVAILABLE_COUNTRY,
  UK_CENTER,
} from 'src/const';
import { COLOR_PRIMARY_2, NEIGHBOURHOOD_THEME } from 'src/colors';
import {
  bfsMergeHexagons,
  calculatePolygonArea,
  calculatePolygonCentroid,
  comparePolygonLimitsToBoundary,
  establishSpatialRelationships,
  extractLatLong,
  generateHexGrid,
  getMedianOccupancyRate,
  getNaturalBreaks,
  getPolygonPaths,
  getScale,
  getSubmarketColor,
  numberOfNeighbourhoodsWithinBound,
  sortListingsByPerformance,
} from '../helper';
import { callApi } from 'src/core/callApi';
import NeighbourhoodPointer from '../UtilityComponents/NeighbourhoodPointer';
import { MapListingCountInfoBox } from 'src/App/HOC/Alerts/MapListingCountInfoBoxAlert';
import { NeighbourhoodToggleBtn } from '../UtilityComponents/NeighbourhoodToggleBtn';
import { MapLegend } from '../UtilityComponents/MapLegend';
import MapFilter from './MapFilter';
import { setTimeout } from 'timers';
import MarketPointer from 'src/App/HOC/Pointer/MarketPointer';
import DiscoverCountryPointer from 'src/App/HOC/Pointer/DiscoverCountryPointer';

const classifyPoint = require('robust-point-in-polygon');

const MAP_FILL_COLOR = POINTER_GREEN;

const Map = ({
  matches,
  search,
  dashboardLayoutView,
  setDashboardLayoutView,
  setDynamicTrigger,
  setSearchLimitAlertBox,
  zoom,
  setZoom,
  bounds,
  setBounds,
  listings,
  setListings,
  visibleListings,
  visibleListingIDs,
  otaListings,
  setOTAListings,
  multipleBookingMarkersCallLoading,
  isDisabled,
  isUserAllowed,
  revPotentialRangeInvestment,
  subscriptionModalOpen,
  currency,
  filteredListings,
  filteredOTAListings,
  visibleOTAListings,
  visibleOTAListingIDs,
  multipleMarkersCallLoading,
  setSubscriptionModalOpen,
  user,
  isLoggedIn,
  setLoginModalOpen,
  setShowSearchCreditDeductWarningModal,
  handleOnSampleClick,
  applyFilter,
  filterActive,
  setShowPremiumDataDynamic,
  toggleDrawer,
  setFilterVal,
  filterVal,
  setFilterActive,
  noDataInMarket,
  topPerformingListingOnFocus,
  showNeighbourhood,
  setShowNeighbourhood,
  setListingsGridStartIndexOffset,
  dummyMarketData,
  discoveryMarkets,
  setDiscoveryMarkets,
  topPerformingMarketOnFocus,
  setTopPerformingMarketOnFocus,
  marketsToCompareList,
  setMarketsToCompareList,
  minROI,
  maxROI,
  isMarketDataAccessible,
  freeMarketDataKey,
  isDiscoveryMapViewOpen,
  setIsDiscoveryMapViewOpen,
  isTabChanging,
  filteredDiscoveryMarkets,
  selectedDiscoveryCountry,
  setSelectedDiscoveryCountry,
  allRawMarketData,
  mapWidth,
  setIsDynamicDataBtnVisible,
}: MapPropTypes) => {
  const {
    polygon_to_use,
    isPolyToUseMultiPolygon,
    center_to_use,
    fixed_center_in_mobile_view,
    discovery_default_zoom_level,
    redirect_to_us,
  } = getDiscoveryMapViewParamsCountryWise(selectedDiscoveryCountry);

  const [mapCenter, setMapCenter] = useState<{ lat: number; lng: number }>({
    lat: search.data.lat,
    lng: search.data.lng,
  });

  const [mapZoomButtonRef, setMapZoomButtonRef] = useState<any>(null);

  const [clusterMarkers, setClusterMarkers] = useState<(JSX.Element | undefined)[] | null>(null);
  const [discoveryMarkers, setDiscoveryMarkers] = useState<(JSX.Element | undefined)[] | null>(
    null
  );

  const NEIGHBOURHOOD_IDEAL_sAMPLE_SIZE = 50;
  const [mapCopy, setMapCopy] = useState<any>(null);
  const [mapsCopy, setMapsCopy] = useState<any>(null);
  const [searchPolygonCopy, setSearchPolygonCopy] = useState<any>(null);
  const [discoveryPolygonCopy, setDiscoveryPolygonCopy] = useState<any>(null);
  const [manualNeighbourhoodToggle, setManualNeighbourhoodToggle] = useState(false);
  const [submarketObjs, setSubmarketObjs] = useState<Submarket[]>([]);
  const submarketPolygonSetRef = useRef(false);
  const [submarketPolygonReferences, setSubmarketPolygonReferences] = useState<any>([]);
  const [neighbourhoodChoroplethLegends, setNeighbourhoodChoroplethLegends] = useState<any>({});
  const [neighbourhoodAnalysisKey, setNeighbourhoodAnalysisKey] = useState<string>('listing');
  const [submarketCachedata, setsubmarketCachedata] = useState<any>();

  const [polygonCopiesDiscovery, setPolygonCopiesDiscovery] = useState<any | null>(null);
  const [discoveryMapBounds, setDiscoveryMapBounds] = useState<GoogleMapReact.Bounds | null>(null);
  const [notSelectedDiscoveryCountryPolygons, setNotSelectedDiscoveryCountryPolygons] = useState<
    any[]
  >([]);
  const [notSelectedDiscoveryCountryPointer, setNotSelectedDiscoveryCountryPointer] = useState<
    JSX.Element[]
  >([]);

  const isMarketTab: boolean =
    dashboardLayoutView !== 'discovery' && dashboardLayoutView !== 'compare';

  const [listingsCount, setListingsCount] = useState<{
    listings: number;
    otaListings: number;
  }>({
    listings: 0,
    otaListings: 0,
  });

  const [polygonBounds, setPolygonBounds] = useState<{
    maxLat: number;
    minLat: number;
    maxLng: number;
    minLng: number;
  } | null>(null);

  const debounceTimeoutRef = useRef<Timer | null>(null);
  const throttleTimeoutRef = useRef<Timer | null>(null);

  // toggles map center from different tabs
  useEffect(() => {
    if (!isMarketTab) {
      matches ? setMapCenter(fixed_center_in_mobile_view) : setMapCenter(center_to_use);
    } else {
      setTopPerformingMarketOnFocus(_ => null);
      setMapCenter({ lat: search.data.lat, lng: search.data.lng });
    }
  }, [dashboardLayoutView, selectedDiscoveryCountry]);

  // Explore markets of other country
  useEffect(() => {
    if (notSelectedDiscoveryCountryPolygons.length) {
      notSelectedDiscoveryCountryPolygons.forEach(polygon => {
        polygon.setMap(null);
      });
      setNotSelectedDiscoveryCountryPolygons([]);
    }
    setNotSelectedDiscoveryCountryPointer([]);

    if (selectedDiscoveryCountry == '') return;

    const tempNonSelectedMarketPolygonsArray: any[] = [];
    const tempNonSelectedMarketPointer: JSX.Element[] = [];

    Object.keys(AVAILABLE_COUNTRY).forEach(countryCode => {
      if (selectedDiscoveryCountry !== countryCode) {
        const currentCountryGeometry = getDiscoveryMapViewParamsCountryWise(countryCode);
        const currentCountryPolygon = currentCountryGeometry.polygon_to_use;
        const curentCountryCenter = currentCountryGeometry.center_to_use;
        const isPolyToUseMultiPolygon = currentCountryGeometry.isPolyToUseMultiPolygon;

        if (
          mapCopy &&
          mapsCopy &&
          (dashboardLayoutView === 'discovery' || dashboardLayoutView === 'compare')
        ) {
          const paths = getPolygonPaths(
            isPolyToUseMultiPolygon ? '' : currentCountryPolygon,
            isPolyToUseMultiPolygon ? currentCountryPolygon : ''
          );
          const polygon = setPolygon(mapCopy, mapsCopy, paths, COLOR_PRIMARY_DARK, MAP_FILL_COLOR);
          tempNonSelectedMarketPolygonsArray.push(polygon);
          tempNonSelectedMarketPointer.push(
            <DiscoverCountryPointer
              lat={curentCountryCenter.lat}
              lng={curentCountryCenter.lng}
              countryCode={countryCode as DiscoveryCountryAvailableType}
              handleClick={() => {
                setSelectedDiscoveryCountry(countryCode as DiscoveryCountryAvailableType);
                window.history.pushState('', '', '/markets/' + countryCode);
              }}
            />
          );
        }
      }
    });

    tempNonSelectedMarketPolygonsArray.length > 0 &&
      setNotSelectedDiscoveryCountryPolygons(tempNonSelectedMarketPolygonsArray);
    tempNonSelectedMarketPointer.length > 0 &&
      setNotSelectedDiscoveryCountryPointer(tempNonSelectedMarketPointer);
  }, [dashboardLayoutView, selectedDiscoveryCountry, mapCopy, mapsCopy]);

  // User Refresh the visible listing calculation after listing count is updated.
  useEffect(() => {
    const currentListingsCount: number = listings.data ? Object.keys(listings.data).length : 0;
    const currentOTAListingsCount: number = otaListings.data
      ? Object.keys(otaListings.data).length
      : 0;

    if (
      listingsCount.listings !== currentListingsCount ||
      listingsCount.otaListings !== currentOTAListingsCount
    ) {
      setListingsCount(_ => ({
        listings: currentListingsCount,
        otaListings: currentOTAListingsCount,
      }));
    }
  }, [listings.data, otaListings.data]);

  useEffect(() => {
    if (filterActive) {
      applyFilter();
    }
  }, [listingsCount.listings]);

  // this is to fetch cached data for submarket analysis
  useEffect(() => {
    const fetchData = async () => {
      try {
        const URL =
          'https://kqypxjqy92.execute-api.us-east-2.amazonaws.com/default/getMarketListingsCoordinates';
        const res = await callApi(
          URL,
          {
            queryParams: {
              name: search.data.name,
              city: search.data.city,
              countryCode: search.data.countryCode,
            },
          },
          false
        );
        setsubmarketCachedata(res.message);
      } catch (error) {
        console.error('Error fetching submarket cache data:', error);
      }
    };
    if (search.data.name || search.data.city || search.data.countryCode) {
      fetchData();
    }
  }, [search]);

  useEffect(() => {
    let timeout: any = null;
    if (isUserAllowed && !multipleMarkersCallLoading) {
      timeout = setTimeout(() => {
        setNeighbourhoodAnalysisKey('occupancy');
      }, 500);
    }

    return () => timeout && clearTimeout(timeout);
  }, [isUserAllowed, multipleMarkersCallLoading]);

  useEffect(() => {
    if (showNeighbourhood) {
      setClusterMarkers(_ => []);
    } else {
      makeClusterMarkers();
    }
  }, [visibleListingIDs, multipleBookingMarkersCallLoading, showNeighbourhood]);

  useEffect(() => {
    const zoomButton = document.querySelector('[aria-label="Zoom in"]');
    setMapZoomButtonRef(zoomButton);
  }, [listingsCount, zoom]);

  useEffect(() => {
    const handleClick = () => {
      if (dashboardLayoutView !== 'map') {
        setDashboardLayoutView('map');
      }
    };

    if (mapZoomButtonRef) {
      mapZoomButtonRef.addEventListener('click', handleClick);
    }

    return () => {
      if (mapZoomButtonRef) {
        mapZoomButtonRef.removeEventListener('click', handleClick);
      }
    };
  }, [zoom, mapZoomButtonRef]);

  const setPolygonColor = (polygon, strokeColor: string, fillColor: string) => {
    polygon.setOptions({
      strokeColor: strokeColor,
      fillColor: fillColor,
    });
  };

  const { clusters } = useSupercluster({
    points: convertListingsIntoGeoJSONArray(visibleListings.data ? visibleListings.data : [], []),
    // @ts-ignore
    bounds: convertBoundsObjToArray(bounds),
    zoom,
    options: { radius: 75, maxZoom: 22 },
  });

  const makeClusterMarkers = () => {
    let clusteredMarkers: any[] = [];
    if (clusters && clusters.length > 0) {
      clusteredMarkers = clusters.map(cluster => {
        const [longitude, latitude] = cluster.geometry.coordinates;
        const { point_count: totalListingsNumInThisCluster } = cluster.properties;

        if (totalListingsNumInThisCluster > 0) {
          const pointSize: number =
            20 + (totalListingsNumInThisCluster / visibleListingIDs.length) * 40;

          return (
            <ClusterPointer
              key={`listing-cluster-${cluster.id}`}
              id={cluster.id}
              lat={latitude}
              lng={longitude}
              pointSize={pointSize}
              totalListingsNumInThisCluster={totalListingsNumInThisCluster}
            />
          );
        }
        return;
      });
    }

    setClusterMarkers(_ => clusteredMarkers);
  };

  const discoverMarketChip = (visibleDiscoveryMarkets: any = null) => {
    let clusteredDiscoveryMarkers: any[] = [];
    setDiscoveryMarkers(null);
    if (discoveryMarkets || visibleDiscoveryMarkets) {
      clusteredDiscoveryMarkers = (visibleDiscoveryMarkets
        ? visibleDiscoveryMarkets
        : discoveryMarkets
      )
        .filter(marketData => {
          return filteredDiscoveryMarkets.has(
            marketData.district + marketData.city + marketData.countryCode
          );
        })
        .slice(0, 10)
        .reverse()
        .map(marketData => {
          const [longitude, latitude]: [number, number] = marketData.center
            .slice(6, marketData.center.length - 1)
            .split(' ')
            .map(Number);

          return (
            <MarketPointer
              key={`listing-cluster-${marketData.district}-${
                marketData.ten_years_roi
              }-${Math.random()}`}
              id={marketData.district}
              lat={latitude}
              lng={longitude}
              countryCode={marketData.country_code}
              pointSize={20}
              name={marketData.district as string}
              score={marketData.ten_years_roi}
              data={marketData}
              isHighlighted={
                topPerformingMarketOnFocus &&
                topPerformingMarketOnFocus.district === marketData.district
              }
              marketsToCompareList={marketsToCompareList}
              setMarketsToCompareList={setMarketsToCompareList}
              dashboardLayoutView={dashboardLayoutView}
              minROI={minROI}
              maxROI={maxROI}
              isMarketDataAccessible={isMarketDataAccessible}
              currency={currency}
              freeMarketDataKey={freeMarketDataKey}
              handleOnSampleClick={handleOnSampleClick}
              marketLength={allRawMarketData ? allRawMarketData.length : 0}
            />
          );
        });

      setDiscoveryMarkers(clusteredDiscoveryMarkers);
    }
  };

  const [memoisedListings, memoisedOTAListings] = useMemo(() => {
    if (listings.loading) {
      return [{}, {}];
    }

    const boundedListings = getBoundedListings(listings.data, bounds);
    const boundedOTAListings = getBoundedOTAListings(otaListings.data, bounds);

    const visibleListings = new Set(
      getVisibleListings(
        boundedListings,
        filteredListings && dashboardLayoutView === 'map' ? filteredListings : boundedListings
      )
    );
    const visibleOTAListings = new Set(
      getVisibleOTAListings(
        boundedOTAListings,
        filteredOTAListings ? filteredOTAListings : boundedOTAListings
      )
    );

    const updatedListings = updateListings(listings.data, visibleListings);
    const updatedOTAListings = updateListings(otaListings.data, visibleOTAListings);

    return [updatedListings, updatedOTAListings];
  }, [listingsCount, bounds]);

  useEffect(() => {
    setListings(memoisedListings);
    setOTAListings(memoisedOTAListings);
  }, [memoisedListings, memoisedOTAListings]);

  useEffect(() => {
    if (topPerformingMarketOnFocus) {
      let center = topPerformingMarketOnFocus.center;
      const { latitude, longitude } = extractLatLong(center);
      setMapCenter({ lat: latitude, lng: longitude });
    }
  }, [topPerformingMarketOnFocus]);

  useEffect(() => {
    discoveryMapBounds
      ? getVisibleDiscoveryPolygons(
          discoveryMapBounds as GoogleMapReact.Bounds,
          topPerformingMarketOnFocus,
          dummyMarketData,
          marketsToCompareList
        )
      : discoverMarketChip();
  }, [
    filteredDiscoveryMarkets,
    dashboardLayoutView,
    marketsToCompareList,
    selectedDiscoveryCountry,
    dummyMarketData,
  ]);

  const getVisibleDiscoveryPolygons = (
    bounds: GoogleMapReact.Bounds,
    topPerformingMarketOnFocus: any = null,
    dummyMarketData: any[] = [],
    marketsToCompareList: any[] = []
  ) => {
    const visibleDiscoveryMarkets: any[] = [];
    if (topPerformingMarketOnFocus) {
      visibleDiscoveryMarkets.push(topPerformingMarketOnFocus);
    }

    if (marketsToCompareList) {
      for (let data of marketsToCompareList) {
        dummyMarketData &&
          dummyMarketData.forEach(market => {
            if (data[0] === market.district) {
              visibleDiscoveryMarkets.push(market);
            }
          });
      }
    }

    dummyMarketData &&
      dummyMarketData.forEach(market => {
        const isThisMarketCenterVisible = isPointWithinBounds(market.center, bounds);
        if (isThisMarketCenterVisible) {
          visibleDiscoveryMarkets.push(market);
        }
      });

    discoverMarketChip(visibleDiscoveryMarkets);
    setDiscoveryMarkets(mapWidth === 0 ? visibleDiscoveryMarkets : dummyMarketData);

    return visibleDiscoveryMarkets;
  };

  const alertIfUserOutOfRange = center => {
    const lat1: number = center.lat;
    const lng1: number = center.lng;
    const lat2: number = search.data.lat;
    const lng2: number = search.data.lng;
    const distance: number = coordDistance(lat1, lng1, lat2, lng2);

    if (distance > 1500) {
      setSearchLimitAlertBox(true);
    } else {
      setSearchLimitAlertBox(false);
    }
  };

  const updateMarketDetailsPremiumDataVisibility = (bounds: Bounds, isUserAllowed: boolean) => {
    const { isInside: isPolygonInsideOfBounds } = comparePolygonLimitsToBoundary(
      polygonBounds,
      bounds,
      20
    );

    if (!isUserAllowed && !isPolygonInsideOfBounds) {
      setShowPremiumDataDynamic(false);
    } else if (isPolygonInsideOfBounds) {
      setShowPremiumDataDynamic(true);
    }
  };

  const handleMapChange = useCallback(
    ({ center, bounds, zoom }: GoogleMapReact.ChangeEventValue) => {
      if (isTabChanging) {
        return;
      }

      if (isMarketTab) {
        listingsCount.listings > 0 && setIsDynamicDataBtnVisible(true);

        if (!throttleTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current!);

          debounceTimeoutRef.current = setTimeout(async () => {
            const boundsObj = formatGoogleMapsBounds(bounds);
            setBounds(boundsObj);
            setZoom(zoom);
            setListingsGridStartIndexOffset(_ => 0);
            alertIfUserOutOfRange(center);
            polygonBounds && updateMarketDetailsPremiumDataVisibility(boundsObj, isUserAllowed);
          }, 500);

          throttleTimeoutRef.current = setTimeout(() => {
            throttleTimeoutRef.current = null;
          }, 500);
        }
      } else {
        setDiscoveryMapBounds(bounds);

        getVisibleDiscoveryPolygons(
          bounds,
          topPerformingMarketOnFocus,
          dummyMarketData,
          marketsToCompareList
        );
      }
    },
    [
      isMarketTab,
      isUserAllowed,
      topPerformingMarketOnFocus,
      marketsToCompareList,
      dummyMarketData,
      isTabChanging,
      listingsCount,
      dashboardLayoutView,
    ]
  );

  const sortObjectByDateKey = obj => {
    const sortedArray = Object.entries(obj)
      .sort(([a], [b]) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        return dateB.getTime() - dateA.getTime();
      })
      .map(([key, value]) => ({ [key]: value }));

    return sortedArray;
  };

  const calculateOccupancyYearlyChange = listings => {
    let totalAllListingOccupancyChange = 0;
    if (neighbourhoodAnalysisKey === 'occupancyRateYearly') {
      for (let listing of listings) {
        let sortedData = sortObjectByDateKey(listing.historicalMonthlyPerformance);
        let latestYearData = sortedData.slice(0, 12);
        let lastYearData = sortedData.slice(12, 25);
        let latestYearOccupancySum = 0;
        let lastYearOccupancySum = 0;
        for (let obj of latestYearData) {
          let data = Object.values(obj)[0] as { bookedDaysCount: number; activeDaysCount: number };
          if (data) {
            let occupancyRate = data['bookedDaysCount'] / data['activeDaysCount'];
            latestYearOccupancySum += +occupancyRate;
          }
        }
        for (let obj of lastYearData) {
          let data = Object.values(obj)[0] as { bookedDaysCount: number; activeDaysCount: number };
          if (data) {
            let occupancyRate = data['bookedDaysCount'] / data['activeDaysCount'];
            lastYearOccupancySum += +occupancyRate;
          }
        }

        if (latestYearOccupancySum > 0 && lastYearOccupancySum > 0) {
          totalAllListingOccupancyChange =
            ((latestYearOccupancySum - lastYearOccupancySum) / lastYearOccupancySum) * 100;
        }
      }
      return parseFloat((totalAllListingOccupancyChange / listings.length).toFixed(1));
    } else {
      return totalAllListingOccupancyChange;
    }
  };

  const setPolygon = (
    map,
    maps,
    paths: Coordinates[][],
    strokeColor: string,
    fillColor: string,
    strokeOpacity = 0.8,
    strokeWeight = 2,
    fillOpacity = 0.12
  ) => {
    const polygon = new maps.Polygon({
      paths: paths,
      strokeColor: strokeColor,
      strokeOpacity: strokeOpacity,
      strokeWeight: strokeWeight,
      fillColor: fillColor,
      fillOpacity: fillOpacity,
    });
    polygon.setMap(map);

    // set dashboard to map view on interaction with map/polygons
    maps.event.addListener(polygon, 'click', function(e) {
      if (!localStorage.getItem('map-flag')) {
        setDashboardLayoutView('map');
        localStorage.setItem('map-flag', 'true');
      }
    });

    maps.event.addListener(map, 'dragend', function(e) {
      if (!localStorage.getItem('map-flag')) {
        setDashboardLayoutView('map');
        localStorage.setItem('map-flag', 'true');
      }
    });

    return polygon;
  };

  const apiIsLoaded = (map, maps, polygonRaw: string, multiPolygonRaw: string) => {
    if (isMarketTab) {
      polygonCopiesDiscovery &&
        Object.keys(polygonCopiesDiscovery).forEach(polygonID => {
          polygonCopiesDiscovery[polygonID].setMap(null);
        });
      setPolygonCopiesDiscovery(null);
      const paths = getPolygonPaths(polygonRaw, multiPolygonRaw);
      const polygon = setPolygon(map, maps, paths, COLOR_PRIMARY_DARK, MAP_FILL_COLOR);
      // applySmartBounds(map, maps, {} as Bounds, polygon);
      setSearchPolygonCopy(polygon);
      setPolygonBounds(calculateBounds(paths));
    }

    setMapCopy(map);
    setMapsCopy(maps);
  };

  useEffect(() => {
    if (isMarketTab && mapCopy && mapsCopy && search.data) {
      discoveryPolygonCopy && discoveryPolygonCopy.setMap(null);
      searchPolygonCopy && searchPolygonCopy.setMap(null);
      polygonCopiesDiscovery &&
        Object.keys(polygonCopiesDiscovery).forEach(polygonID => {
          polygonCopiesDiscovery[polygonID].setMap(null);
        });
      setPolygonCopiesDiscovery(null);

      setMapCenter({ lat: search.data.lat, lng: search.data.lng });
      setZoom(_ => 12);

      const paths = getPolygonPaths(search.data.polygon, search.data.multiPolygon);
      const polygon = setPolygon(mapCopy, mapsCopy, paths, COLOR_PRIMARY_DARK, MAP_FILL_COLOR);
      // applySmartBounds(mapCopy, mapsCopy, {} as Bounds, polygon);
      setSearchPolygonCopy(polygon);
      setPolygonBounds(calculateBounds(paths));
    } else {
      searchPolygonCopy && searchPolygonCopy.setMap(null);
      !isMarketTab && setZoom(discovery_default_zoom_level);
    }
  }, [
    dashboardLayoutView,
    marketsToCompareList,
    selectedDiscoveryCountry,
    filteredDiscoveryMarkets,
  ]);

  useEffect(() => {
    if (
      mapCopy &&
      mapsCopy &&
      (dashboardLayoutView === 'discovery' || dashboardLayoutView === 'compare')
    ) {
      discoveryPolygonCopy && discoveryPolygonCopy.setMap(null);
      const paths = getPolygonPaths(
        isPolyToUseMultiPolygon ? '' : polygon_to_use,
        isPolyToUseMultiPolygon ? polygon_to_use : ''
      );
      const polygon = setPolygon(mapCopy, mapsCopy, paths, COLOR_PRIMARY_DARK, MAP_FILL_COLOR);
      setDiscoveryPolygonCopy(polygon);
    } else {
      discoveryPolygonCopy && discoveryPolygonCopy.setMap(null);
    }
  }, [mapCopy, mapsCopy, dashboardLayoutView, selectedDiscoveryCountry]);

  const getPointerColor = (
    isDisabled: boolean,
    item: Listing,
    revPotentialRangeInvestment: { [key: number]: 'visible' | 'hidden' } = {}
  ) => {
    if (!isDisabled && !item.revenuePotential) {
      return COLOR_AIRBNB_MARKERS;
    }

    if (isDisabled && item.revenuePercentileRating) {
      return COLOR_RANGE_AIRBNB_MARKERS[item.revenuePercentileRating];
    }

    const revPotentialRange = Object.keys(revPotentialRangeInvestment)
      .map(Number)
      .sort((a, b) => a - b);

    for (let i = 0; i < 4; i++) {
      const currentRevPotential: number = revPotentialRange[i];
      if (item.revenuePotential <= currentRevPotential) {
        return COLOR_RANGE_AIRBNB_MARKERS[i];
      }
    }

    return COLOR_RANGE_AIRBNB_MARKERS[0];
  };

  const markers = useMemo(() => {
    if (visibleListingIDs.length) {
      const safeVisibleListings: Listing[] = safeMarkersLoad(
        sortListingsByPerformance(visibleListings.data),
        isUserAllowed,
        !showNeighbourhood && dashboardLayoutView === 'map'
      );
      return safeVisibleListings.map((item: Listing, index: number) => {
        let color: string = getPointerColor(isDisabled, item, revPotentialRangeInvestment);

        return (
          <Pointer
            key={index}
            lat={item.latitude}
            lng={item.longitude}
            setSubscriptionModalOpen={setSubscriptionModalOpen}
            data={item}
            canDelete={true}
            isDisabled={isDisabled}
            currency={currency}
            subscriptionModalOpen={subscriptionModalOpen}
            multipleBookingMarkersCallLoading={multipleBookingMarkersCallLoading}
            color={color}
            market={search.data.name}
            handleOnSampleClick={handleOnSampleClick}
            user={user}
            topPerformingListingOnFocus={topPerformingListingOnFocus}
            isEstimator={false}
          />
        );
      });
    }
    return;
  }, [
    visibleListingIDs,
    currency,
    multipleBookingMarkersCallLoading,
    revPotentialRangeInvestment,
    topPerformingListingOnFocus,
  ]);

  const otaMarkers = useMemo(() => {
    if (visibleOTAListingIDs.length) {
      const safeVisibleOTAListings = safeOTAMarkersLoad(visibleOTAListings.data, isUserAllowed);
      return safeVisibleOTAListings.map((data, index) => (
        <SimplePointer lat={data.lat} lng={data.lng} data={data} />
      ));
    }
    return null;
  }, [visibleOTAListingIDs]);

  const neighbourhoodMarkers = useMemo(() => {
    return submarketObjs.map(submarketObj => {
      const centroid = calculatePolygonCentroid(submarketObj.path[0]);
      const scale = getScale(zoom);
      return (
        <NeighbourhoodPointer
          lat={centroid.lat}
          lng={centroid.lng}
          listings={submarketObj.listings}
          currency={currency}
          isUserAllowed={isUserAllowed}
          multipleMarkersCallLoading={multipleMarkersCallLoading}
          user={user}
          isLoggedIn={isLoggedIn}
          setLoginModalOpen={setLoginModalOpen}
          setShowSearchCreditDeductWarningModal={setShowSearchCreditDeductWarningModal}
          setSubscriptionModalOpen={setSubscriptionModalOpen}
          scale={scale}
          neighbourhoodObj={submarketObj}
          neighbourhoodAnalysisKey={neighbourhoodAnalysisKey}
        />
      );
    });
  }, [submarketObjs, isUserAllowed, currency, multipleMarkersCallLoading, user, isLoggedIn, zoom]);

  const getVisibleNeighbourhoodPointerAsPerNeighbourhoodSizeAndzoomLevel = useMemo(() => {
    // This code is responsible to show chip on neighbourhood polygon based on neighbourhood polygon area and zoom level
    if (submarketObjs.length > 0) {
      if (zoom < 10) {
        return [];
      }
      const singleRandomNeighbourhood = submarketObjs[0];
      const neighbourhoodArea = calculatePolygonArea(singleRandomNeighbourhood['path'][0]);
      if (neighbourhoodArea < 0.00009) {
        // Country like Paris
        if (zoom < 12) {
          return [];
        } else if (zoom <= 13) {
          return neighbourhoodMarkers.filter((element, index) => index % 3 === 0).slice(0, 10);
        } else if (zoom == 14) {
          return neighbourhoodMarkers.filter((element, index) => index % 4 === 0);
        } else {
          return neighbourhoodMarkers;
        }
      } else if (neighbourhoodArea >= 0.00009 && neighbourhoodArea < 0.0006) {
        // Country like Brighton, Amsterdam
        if (zoom <= 10) {
          return [];
        }
        if (zoom == 11) {
          return neighbourhoodMarkers.filter((element, index) => index % 3 === 0).slice(0, 10);
        } else if (zoom == 12) {
          return neighbourhoodMarkers.filter((element, index) => index % 4 === 0);
        } else {
          return neighbourhoodMarkers;
        }
      } else if (neighbourhoodArea >= 0.0006 && neighbourhoodArea < 0.09) {
        // Country like Malibu, Huston
        if (zoom <= 9) {
          return neighbourhoodMarkers.filter((element, index) => index % 3 === 0).slice(0, 10);
        } else if (zoom == 10) {
          return neighbourhoodMarkers.filter((element, index) => index % 4 === 0);
        } else {
          return neighbourhoodMarkers;
        }
      } else {
        // Country like New York
        if (zoom <= 8) {
          return neighbourhoodMarkers.filter((element, index) => index % 3 === 0).slice(0, 10);
        } else if (zoom == 9) {
          return neighbourhoodMarkers.filter((element, index) => index % 4 === 0);
        } else {
          return neighbourhoodMarkers;
        }
      }
    } else {
      return [];
    }
  }, [submarketObjs, zoom, neighbourhoodMarkers]);

  useEffect(() => {
    if (!isUserAllowed && neighbourhoodAnalysisKey != 'listing') {
      handleOnSampleClick();
      setNeighbourhoodAnalysisKey('listing');
    }
  }, [neighbourhoodAnalysisKey]);

  // submarket analysis

  useEffect(() => {
    if (
      !mapCopy ||
      !mapsCopy ||
      search.loading ||
      (!search.data.polygon && !search.data.multiPolygon) ||
      !submarketCachedata ||
      dashboardLayoutView == 'discovery'
    )
      return;

    if (!showNeighbourhood) {
      // remove subamrket polygons
      if (submarketPolygonReferences.length > 0) {
        submarketPolygonReferences.forEach(submarketPolygon => submarketPolygon.setMap(null));
        submarketPolygonSetRef.current = false;
      }
      return;
    }

    // check if submarket polygons are already set remove it and create a new polygon
    if (submarketPolygonSetRef.current) {
      submarketPolygonReferences.forEach(submarketPolygon => submarketPolygon.setMap(null));
      submarketPolygonSetRef.current = false;
    }

    // explode the market map in hexagonal grids
    let hexGrid;
    if (multipleMarkersCallLoading) {
      hexGrid = generateHexGrid(search.data.polygon, search.data.multiPolygon, submarketCachedata);
    } else {
      hexGrid = generateHexGrid(search.data.polygon, search.data.multiPolygon, listings.data);
    }

    // transform the hexagonal grid into neighbourhoods by setting listings count metadata
    const neighbourhoods = hexGrid.map(hexagon => {
      let listingsInHexagon: ListingVal[] = [];
      if (!hexagon)
        return {
          coordinates: [],
          listings: [],
        };

      // Check if all listings are loaded then show actual data else show cache
      if (multipleMarkersCallLoading) {
        submarketCachedata.forEach(coord => {
          if (classifyPoint(hexagon[0], coord) === -1 || classifyPoint(hexagon[0], coord) === 0) {
            listingsInHexagon.push(coord);
          }
        });
      } else {
        Object.values(listings.data).forEach(listing => {
          const point = [listing.longitude, listing.latitude];
          if (classifyPoint(hexagon[0], point) === -1 || classifyPoint(hexagon[0], point) === 0)
            listingsInHexagon.push(listing);
        });
      }

      return {
        coordinates: hexagon[0],
        listings: listingsInHexagon,
      };
    });

    const filteredNeighbourhoods = neighbourhoods.filter(
      neighbourhood => neighbourhood.listings.length > 0
    );

    // merge the neighbourhoods untill each neighbourhood has minimum half of the ideal listings count
    const neighbourhoodMergingMinThreshold = NEIGHBOURHOOD_IDEAL_sAMPLE_SIZE / 2;
    let spatialRelationships = establishSpatialRelationships(filteredNeighbourhoods);
    let mergedNeighbourhoods: any = filteredNeighbourhoods;
    let isFirstIteration = true;

    while (
      isFirstIteration ||
      mergedNeighbourhoods.some(
        (neighbourhood, index) =>
          neighbourhood.listings.length < neighbourhoodMergingMinThreshold &&
          spatialRelationships[index].length > 0
      )
    ) {
      mergedNeighbourhoods = bfsMergeHexagons(
        mergedNeighbourhoods,
        spatialRelationships,
        neighbourhoodMergingMinThreshold
      );
      spatialRelationships = establishSpatialRelationships(mergedNeighbourhoods);
      isFirstIteration = false;
    }

    // submarkets are ready
    const submarkets: Submarket[] = mergedNeighbourhoods.map((neighbourhood, index) => {
      let listingCount = neighbourhood.listings.length;
      let occupancyRateYearlyChange = calculateOccupancyYearlyChange(neighbourhood.listings);
      const hexagonPath = neighbourhood.coordinates.map(coord => ({
        lng: coord[0],
        lat: coord[1],
      }));
      const medianOccupancyRate = getMedianOccupancyRate(neighbourhood.listings);
      return {
        ...neighbourhood,
        path: [hexagonPath],
        occupancyRate: medianOccupancyRate,
        id: index,
        listingCount: listingCount,
        occupancyRateYearlyChange: occupancyRateYearlyChange,
      };
    });
    // set vhropleth graph breaks and assign colors to submarkets
    const submarketOccupancyRates = submarkets.map(submarket => submarket.occupancyRate);
    const validSubmarketOccupancyRates = submarketOccupancyRates.filter(
      rate => rate !== undefined && !Number.isNaN(rate)
    );

    const submarketListingCounts = submarkets.map(submarket => submarket.listingCount);
    const validSubmarketListingsCounts = submarketListingCounts.filter(
      count => count !== undefined && !Number.isNaN(count)
    );

    const submarketOccupancyRateYearlyChange = submarkets.map(
      submarket => submarket.occupancyRateYearlyChange
    );
    const validSubmarketOccupancyRateYearlyChange = submarketOccupancyRateYearlyChange.filter(
      rate => rate !== undefined && !Number.isNaN(rate)
    );

    let choroplethBreaks;
    if (neighbourhoodAnalysisKey === 'occupancy') {
      choroplethBreaks = getNaturalBreaks(validSubmarketOccupancyRates);
    }
    if (neighbourhoodAnalysisKey === 'listing') {
      choroplethBreaks = getNaturalBreaks(validSubmarketListingsCounts);
    }

    if (neighbourhoodAnalysisKey === 'occupancyRateYearly') {
      choroplethBreaks = getNaturalBreaks(validSubmarketOccupancyRateYearlyChange);
    }

    const legends = {
      [`< ${choroplethBreaks[0] + 1}${
        neighbourhoodAnalysisKey !== 'listing' ? '%' : ''
      }`]: NEIGHBOURHOOD_THEME[0],
      [`${choroplethBreaks[0] + 1}${neighbourhoodAnalysisKey !== 'listing' ? '%' : ''} - ${
        choroplethBreaks[1]
      }${neighbourhoodAnalysisKey !== 'listing' ? '%' : ''}`]: NEIGHBOURHOOD_THEME[1],
      [`${choroplethBreaks[1] + 1}${neighbourhoodAnalysisKey !== 'listing' ? '%' : ''} - ${
        choroplethBreaks[2]
      }${neighbourhoodAnalysisKey !== 'listing' ? '%' : ''}`]: NEIGHBOURHOOD_THEME[2],
      [`${choroplethBreaks[2] + 1}${neighbourhoodAnalysisKey !== 'listing' ? '%' : ''} - ${
        choroplethBreaks[3]
      }${neighbourhoodAnalysisKey !== 'listing' ? '%' : ''}`]: NEIGHBOURHOOD_THEME[3],
      [`> ${choroplethBreaks[3]}${
        neighbourhoodAnalysisKey !== 'listing' ? '%' : ''
      }`]: NEIGHBOURHOOD_THEME[4],
    };
    setNeighbourhoodChoroplethLegends(legends);

    let submarketPolygons: any[] = [];

    isMarketTab &&
      submarkets.forEach(submarket => {
        const submarketKey =
          neighbourhoodAnalysisKey === 'occupancy'
            ? submarket.occupancyRate
            : neighbourhoodAnalysisKey === 'occupancyRateYearly'
            ? submarket.occupancyRateYearlyChange
            : submarket.listingCount;
        const color = getSubmarketColor(submarketKey, choroplethBreaks, neighbourhoodAnalysisKey);
        const submarketPolygon = setPolygon(
          mapCopy,
          mapsCopy,
          submarket.path,
          COLOR_PRIMARY_DARK,
          color,
          0.8,
          2,
          0.8
        );
        submarketPolygons.push(submarketPolygon);
      });

    setSubmarketPolygonReferences(submarketPolygons);
    setSubmarketObjs(submarkets);
    submarketPolygonSetRef.current = true;
  }, [
    neighbourhoodAnalysisKey,
    multipleMarkersCallLoading,
    mapCopy,
    mapsCopy,
    showNeighbourhood,
    search,
    submarketCachedata,
    dashboardLayoutView,
    listingsCount,
  ]);

  return (
    <>
      {showNeighbourhood && dashboardLayoutView == 'map' && (
        <div
          style={{
            width: '150px',
            padding: '15px',
            background: 'white',
            boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
            borderRadius: 2,
            zIndex: 3,
            position: 'absolute',
            [matches ? 'top' : 'bottom']: matches ? '20px' : '0px',
            right: '0px',
            transform: matches ? 'scale(0.7)' : '',
            transformOrigin: 'bottom right',
          }}
        >
          <Box
            sx={{
              height: '100%',
              width: '200px',
            }}
          >
            <FormControl
              variant="outlined"
              size="small"
              sx={{
                width: 150,
                padding: '0px',
                backgroundColor: COLOR_PRIMARY_2,
                color: '#ffff',
              }}
            >
              <Select
                labelId="percentile-select"
                id="percentile-select"
                value={`${neighbourhoodAnalysisKey}`}
                onChange={event => {
                  setNeighbourhoodAnalysisKey(event.target.value);
                }}
                sx={{
                  color: 'inherit',
                  '& .MuiSvgIcon-root': { color: '#ffff' },
                  '& p': {
                    display: 'flex',
                    alignItems: 'center',
                    height: '40px',
                    wordWrap: 'break-word',
                    whiteSpace: 'normal',
                  },
                }}
              >
                <MenuItem
                  value={'listing'}
                  sx={{ width: '150px', height: '60px', whiteSpace: 'normal' }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    Number Of Listings
                  </Typography>
                </MenuItem>
                <MenuItem
                  value={'occupancy'}
                  disabled={Boolean(multipleMarkersCallLoading)}
                  sx={{ width: '150px', height: '60px', whiteSpace: 'normal' }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    Occupancy Rate{' '}
                    {isDisabled ? (
                      <LockSharpIcon style={{ fontSize: 17, color: COLOR_PRIMARY_2 }} />
                    ) : (
                      ''
                    )}
                  </Typography>
                </MenuItem>
              </Select>
            </FormControl>
          </Box>

          {Object.keys(neighbourhoodChoroplethLegends)
            .reverse()
            .map(breakpoint => {
              if (!breakpoint.includes('undefined')) {
                return (
                  <Grid container direction="row" style={{ marginTop: '10px' }} key={breakpoint}>
                    <div
                      style={{
                        width: '20px',
                        height: '20px',
                        background: neighbourhoodChoroplethLegends[breakpoint],
                        borderRadius: '10%',
                        border: '1px rgba(110.06, 110.06, 110.06, 0.32) solid',
                        marginRight: '10px',
                      }}
                    />
                    <Typography variant="body2">{breakpoint}</Typography>
                  </Grid>
                );
              }
              return null;
            })}
        </div>
      )}

      {!visibleListings.loading && !visibleOTAListings.loading && isMarketTab && (
        <MapListingCountInfoBox
          listingsLength={visibleListingIDs.length}
          otaListingsLength={visibleOTAListingIDs.length}
          isMapChanging={false}
        />
      )}

      {isMarketTab && (
        <NeighbourhoodToggleBtn
          matches={matches}
          view={dashboardLayoutView}
          isToggled={showNeighbourhood}
          setNeighbourhoodToggle={setShowNeighbourhood}
          setManualNeighbourhoodToggle={setManualNeighbourhoodToggle}
        />
      )}

      <GoogleMapReact
        bootstrapURLKeys={{
          key: 'AIzaSyDUnmEGqix9gziZQjtCQFJ7mCTSDV9yPDk',
          libraries: ['drawing', 'places', 'visualization'],
          id: 'dashboard2',
        }}
        center={mapCenter}
        options={map => mapOptions(map, false)}
        zoom={zoom}
        resetBoundsOnResize={true}
        onChange={handleMapChange}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map, maps }) =>
          apiIsLoaded(map, maps, search.data.polygon, search.data.multiPolygon)
        }
      >
        {!isTabChanging &&
          isMarketTab &&
          !visibleOTAListings.loading &&
          visibleListingIDs.length <= 60 &&
          otaMarkers}
        {!isTabChanging &&
          isMarketTab &&
          (!visibleListings.loading && visibleListingIDs.length <= 60 && clusterMarkers
            ? markers
            : clusterMarkers)}
        {!isTabChanging &&
          (dashboardLayoutView === 'discovery' || dashboardLayoutView === 'compare') &&
          discoveryMarkers}
        {!isTabChanging &&
          isMarketTab &&
          showNeighbourhood &&
          !visibleListings.loading &&
          markers?.slice(0, 60)}
        {/* dynamically show neighburhood chips to avoid conjestion in dashboard view */}
        {!isTabChanging &&
          isMarketTab &&
          showNeighbourhood &&
          submarketObjs &&
          getVisibleNeighbourhoodPointerAsPerNeighbourhoodSizeAndzoomLevel}
        {notSelectedDiscoveryCountryPointer.length > 0 && notSelectedDiscoveryCountryPointer}
      </GoogleMapReact>
      <MapFilter
        toggleDrawer={toggleDrawer}
        setFilterVal={setFilterVal}
        applyFilter={applyFilter}
        filterVal={filterVal}
        filterActive={filterActive}
        setFilterActive={setFilterActive}
        isDisabled={isDisabled}
        handleOnSampleClick={handleOnSampleClick}
        listingsCount={listingsCount}
        setZoom={setZoom}
        onlyShowZoom={dashboardLayoutView !== 'map' || matches}
        onZoomInClick={() => {
          if (
            dashboardLayoutView !== 'map' &&
            dashboardLayoutView !== 'discovery' &&
            dashboardLayoutView !== 'compare'
          ) {
            setDashboardLayoutView('map');
          }
        }}
        dashboardLayoutView={dashboardLayoutView}
        noDataInMarket={noDataInMarket}
      />
    </>
  );
};

export default React.memo(Map);
